import { render, staticRenderFns } from "./OicList.vue?vue&type=template&id=1da99dac&scoped=true&"
import script from "./OicList.vue?vue&type=script&lang=js&"
export * from "./OicList.vue?vue&type=script&lang=js&"
import style0 from "./OicList.vue?vue&type=style&index=0&id=1da99dac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da99dac",
  null
  
)

export default component.exports